export enum MessageType {
  Error = 'error',
  Scheduled = 'scheduled',
  Pending = 'pending',
}

export const MESSAGE_COUNT_CUTOFF_DAYS = 7;

export enum TimePeriod {
  lastFiveMinutes = '5min',
  lastTenMinutes = '10min',
  lastOneHour = '60min',
}
